// extracted by mini-css-extract-plugin
export default {"cls1":"W6oV92p3176RM1VjYjWG","cls2":"iYjE43rdYIY5XgNrUVor W6oV92p3176RM1VjYjWG"};